<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{ settings[selected].title }}</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <ng-template [ngIf]="selected == 'active'">
          <button class="btn vertical align-items-center" routerLink="/business/vendita/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive'">
          <button class="btn vertical align-items-center" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a Business Vendite
          </button>
        </ng-template>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
            <form  class="table-row-container row first-row filter" [formGroup]="businessSaleForm" (ngSubmit)="filter()" *ngIf="businessSaleForm"> 
                
                <div class="item data-col-5">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.actualOrderId')"> 
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.actualOrderId')"></i>
                      ID ordine effettivo
                    </h4>
                    <span class="data">
                      <input type="number" min="1000" max="10000" formControlName="BusinessSales.actualOrderId">
                    </span>
                </div>

                <div class="item data-col-5">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')"> 
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                      Ordine
                    </h4>
                    <span class="data">
                      <input type="number" min="1000" max="10000" formControlName="BusinessSales.orderId">
                    </span>
                </div>

                <div class="item data-col-10 item">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.deliveryDate')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.deliveryDate')"></i>
                      DATA
                    </h4>
                    <span class="data">
                      <div class="date">Da:</div>
                      <input class="date" type="date" formControlName="BusinessSales.deliveryDate_from">
                    </span>
                    <span class="data">
                      <div class="date">A: </div>
                      <input class="date" type="date" formControlName="BusinessSales.deliveryDate_to">
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                      Cliente
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.orderId">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.address')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.address')"></i>
                      Indirizzo
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.address">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.phone')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.phone')"></i>
                      Telefono
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.phone">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.channel')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.channel')"></i>
                      Canale
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.channel">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.total')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.total')"></i>
                      Totale
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.total">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.paymentStatus')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.paymentStatus')"></i>
                      Stato del pagamento
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.paymentStatus">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.fullFillmentStatus')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.fullFillmentStatus')"></i>
                      Stato di adempimento
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.fullFillmentStatus">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                      Elementi
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.orderId">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                      SKU
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.orderId">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.deliveryMethod')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.deliveryMethod')"></i>
                      metodo di consegna
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.deliveryMethod">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.vendor')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.vendor')"></i>
                      Vendor
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.vendor">  
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('BusinessSales.status')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.status')"></i>
                      Stato
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="BusinessSales.status">  
                    </span>
                </div>

                <div class="item nowrap">
                    <h4 class="title">Azioni</h4>
                    <span class="data btn-container">
                      <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); filter()">
                        RICERCA <i class="fas fa-search"></i></button>
                        <br/>
                      <button class="btn hvr-grow has-margin-right " (click)="resetFilter();">
                        RESET <i class="fas fa-times-circle"></i></button>
                    </span>
                  </div>
                <hr class="hr-clear" />
            </form>

            <div class="table-row-container row" *ngFor="let order of orders">

                <div class="item data-col-10">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      ID ordine effettivo :
                    </h4>
                    <div class="data data-id">
                      <div>#{{ order.actualOrderId || "---" }}</div>
                    </div>
                </div>

                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Ordine
                    </h4>
                    <div class="data data-id">
                      <div>#{{ order.orderId || "---" }}</div>
                    </div>
                </div>

                <div class="item data-col-10">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Data :
                    </h4>
                    <div class="data">
                      <div>{{ ((order.deliveryDate) || "---") + ' at ' + ((order.deliveryTime) || "---") }}</div>
                    </div>
                </div>

                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Cliente :
                    </h4>
                    <div class="data">
                      <div>{{ ( (order.firstName || '-')  + ' ' + (order.lastName || '-')) }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Indirizzo
                    </h4>
                    <div class="data">
                      <div>{{ ( order.address || "---") }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Telefono
                    </h4>
                    <div class="data">
                      <div>{{ ( order.phone || "---") }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Canale
                    </h4>
                    <div class="data">
                      <div>{{ ( order.channel || "---") }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Totale
                    </h4>
                    <div class="data">
                      <div>{{ ( order.total || "---") }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Stato del pagamento
                    </h4>
                    <div class="data">
                      <div>{{ ( order.paymentStatus || "---") }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Stato di adempimento
                    </h4>
                    <div class="data">
                      <div>{{ order.fullFillmentStatus || "Unfullfilled" }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Elementi
                    </h4>
                    <div class="data">
                      <div>{{ myjson.parse(order.lineItems) | arrayJoin:', ':'name' }}</div>
                    </div>
                </div>

                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      SKU
                    </h4>
                    <div class="data">
                      <div>{{ myjson.parse(order.lineItems) | arrayJoin:', ':'sku' }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      metodo di consegna
                    </h4>
                    <div class="data">
                      <div>{{ order.deliveryMethod || "---" }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Vendor
                    </h4>
                    <div class="data">
                      <div>{{ order.vendor || "---" }}</div>
                    </div>
                </div>
                
                <div class="item data-col-5">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Stato
                    </h4>
                    <ng-template [ngIf]="selected == 'active'">
                      {{
                        order.status.toLowerCase() === 'new' || order.status.toLowerCase() === 'notaccepted' || order.status.toLowerCase() === 'refused' ? "Da Gestire" :
                        (order.status.toLowerCase() === 'confirmed' && order?.confirmedBy?.toLowerCase() === 'partner') ? "Vendita Accettata" :
                        (order.status.toLowerCase() === 'confirmed' && (order?.confirmedBy?.toLowerCase() === 'admin' || order?.confirmedBy === null )) ? "Vendita Confermata" :
                        order.status.toLowerCase() === 'emailed' && order.saleType?.toLowerCase() === 'nonunique' ? "Vendita Inviata a " + order?.assignedPartner :
                        order.status.toLowerCase() === 'emailed' || order.status.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() === 'unique' ? "Inserita, Da Accettare" :
                        "--"
                      }}
                    </ng-template>
                    <ng-template [ngIf]="selected == 'inactive'">
                      {{
                        order.status.toLowerCase() === 'new' ? "Da Gestire" :
                        (order.status.toLowerCase() === 'confirmed' && order?.confirmedBy?.toLowerCase() === 'partner') ? "Vendita Accettata" :
                        (order.status.toLowerCase() === 'confirmed' && (order?.confirmedBy?.toLowerCase() === 'admin' || order?.confirmedBy === null )) ? "Vendita Confermata" :
                        order.status.toLowerCase() === 'refused' ? "Vendita Rifiutata" :
                        order.status.toLowerCase() === 'notaccepted' ? "Non accettato" :
                        order.status.toLowerCase() === 'emailed' ? "Vendita Inviata" : "--"
                      }}
                    </ng-template>
                </div>

                <div class="item nowrap">
                  
                    <span class="data-row-left btn-container">
                        <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); confirmSale(order);" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')) && ((order?.status?.toLowerCase() === 'new') || (order?.status?.toLowerCase() === 'notaccepted') )">CONFERMA</button>
                        <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault();" [routerLink]="['/business/vendita/edit', order.id]" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')) && ((order?.status?.toLowerCase() === 'new') || (order?.status?.toLowerCase() === 'notaccepted') )">MODIFICA</button>
                        <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); refuseSale(order.orderId);" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')) && ((order?.status?.toLowerCase() === 'new') || (order?.status?.toLowerCase() === 'notaccepted') )">RIFIUTA</button>
                        <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); stopSaleAutomation(order);" *ngIf="((groups.includes('admin') || groups.includes('operation')) && (order.status.toLowerCase() === 'emailed') && (order.saleType?.toLowerCase() === 'nonunique'))" [disabled]="btnDisable">INTERROMPI</button>
                    </span>
                
                </div>

            </div>
        </div>
    </section>

  </div>
</section>


<!--
<section class="title-bar content-padding first-item">
    <div class="wrapper">
        <h2 class="left">{{settings[selected].title}}</h2>
        <br class="clear">
        <br class="clear">
        <ng-template [ngIf]="selected == 'active'">
            <a routerLink="/business/vendita/storico">
                <span class="btn btn-white  has-margin-right" id="storicoConsegne">Storico<i class="ml-10 far fa-folder"></i></span>
            </a>
        </ng-template>
        <ng-template [ngIf]="selected == 'inactive'">
            <button class="btn btn-white has-margin-right" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
                <i class="ml-10 fas fa-arrow-left"></i>Ritorna a Vendita
            </button>
        </ng-template>
        <div class="right">
        </div>
    </div>
</section>
<section class="main-content wrapper content-padding scroll-delivery">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form  class="table-row-container row first-row filter" [formGroup]="businessSaleForm" (ngSubmit)="filter()" *ngIf="businessSaleForm"> 
            
            <div class="item data-col-5">
                <h4 class="title" (click)="navigateOrder('BusinessSales.actualOrderId')"> 
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.actualOrderId')"></i>
                  ID ordine effettivo
                </h4>
                <span class="data">
                  <input type="number" min="1000" max="10000" formControlName="BusinessSales.actualOrderId">
                </span>
            </div>

            <div class="item data-col-5">
                <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')"> 
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                  Ordine
                </h4>
                <span class="data">
                  <input type="number" min="1000" max="10000" formControlName="BusinessSales.orderId">
                </span>
            </div>

            <div class="item data-col-10 item">
                <h4 class="title" (click)="navigateOrder('BusinessSales.deliveryDate')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.deliveryDate')"></i>
                  DATA
                </h4>
                <span class="data">
                  <div class="date">Da:</div>
                  <input class="date" type="date" formControlName="BusinessSales.deliveryDate_from">
                </span>
                <span class="data">
                  <div class="date">A: </div>
                  <input class="date" type="date" formControlName="BusinessSales.deliveryDate_to">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                  Cliente
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.orderId">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.address')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.address')"></i>
                  Indirizzo
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.address">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.phone')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.phone')"></i>
                  Telefono
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.phone">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.channel')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.channel')"></i>
                  Canale
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.channel">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.total')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.total')"></i>
                  Totale
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.total">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.paymentStatus')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.paymentStatus')"></i>
                  Stato del pagamento
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.paymentStatus">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.fullFillmentStatus')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.fullFillmentStatus')"></i>
                  Stato di adempimento
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.fullFillmentStatus">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                  Elementi
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.orderId">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.orderId')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.orderId')"></i>
                  SKU
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.orderId">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.deliveryMethod')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.deliveryMethod')"></i>
                  metodo di consegna
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.deliveryMethod">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.vendor')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.vendor')"></i>
                  Vendor
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.vendor">  
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('BusinessSales.status')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('BusinessSales.status')"></i>
                  Stato
                </h4>
                <span class="data">
                  <input type="text" formControlName="BusinessSales.status">  
                </span>
            </div>

            <div class="item nowrap">
                <h4 class="title">Azioni</h4>
                <span class="data btn-container">
                  <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); filter()">
                    RICERCA <i class="fas fa-search"></i></button>
                    <br/>
                  <button class="btn hvr-grow has-margin-right " (click)="resetFilter();">
                    RESET <i class="fas fa-times-circle"></i></button>
                </span>
              </div>
            <hr class="hr-clear" />
        </form>

        <div class="table-row-container row" *ngFor="let order of orders">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID ordine effettivo :
                </h4>
                <div class="data data-id">
                  <div>#{{ order.actualOrderId || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Ordine
                </h4>
                <div class="data data-id">
                  <div>#{{ order.orderId || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Data :
                </h4>
                <div class="data">
                  <div>{{ ((order.deliveryDate) || "---") + ' at ' + ((order.deliveryTime) || "---") }}</div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Cliente :
                </h4>
                <div class="data">
                  <div>{{ ( (order.firstName || '-')  + ' ' + (order.lastName || '-')) }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Indirizzo
                </h4>
                <div class="data">
                  <div>{{ ( order.address || "---") }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Telefono
                </h4>
                <div class="data">
                  <div>{{ ( order.phone || "---") }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Canale
                </h4>
                <div class="data">
                  <div>{{ ( order.channel || "---") }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Totale
                </h4>
                <div class="data">
                  <div>{{ ( order.total || "---") }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Stato del pagamento
                </h4>
                <div class="data">
                  <div>{{ ( order.paymentStatus || "---") }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Stato di adempimento
                </h4>
                <div class="data">
                  <div>{{ order.fullFillmentStatus || "Unfullfilled" }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Elementi
                </h4>
                <div class="data">
                  <div>{{ myjson.parse(order.lineItems) | arrayJoin:', ':'name' }}</div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  SKU
                </h4>
                <div class="data">
                  <div>{{ myjson.parse(order.lineItems) | arrayJoin:', ':'sku' }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  metodo di consegna
                </h4>
                <div class="data">
                  <div>{{ order.deliveryMethod || "---" }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Vendor
                </h4>
                <div class="data">
                  <div>{{ order.vendor || "---" }}</div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Stato
                </h4>
                <ng-template [ngIf]="selected == 'active'">
                  {{
                    order.status.toLowerCase() === 'new' || order.status.toLowerCase() === 'notaccepted' || order.status.toLowerCase() === 'refused' ? "Da Gestire" :
                    (order.status.toLowerCase() === 'confirmed' && order?.confirmedBy?.toLowerCase() === 'partner') ? "Vendita Accettata" :
                    (order.status.toLowerCase() === 'confirmed' && (order?.confirmedBy?.toLowerCase() === 'admin' || order?.confirmedBy === null )) ? "Vendita Confermata" :
                    order.status.toLowerCase() === 'emailed' && order.saleType?.toLowerCase() === 'nonunique' ? "Vendita Inviata a " + order?.assignedPartner :
                    order.status.toLowerCase() === 'emailed' || order.status.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() === 'unique' ? "Inserita, Da Accettare" :
                    "--"
                  }}
                </ng-template>
                <ng-template [ngIf]="selected == 'inactive'">
                  {{
                    order.status.toLowerCase() === 'new' ? "Da Gestire" :
                    (order.status.toLowerCase() === 'confirmed' && order?.confirmedBy?.toLowerCase() === 'partner') ? "Vendita Accettata" :
                    (order.status.toLowerCase() === 'confirmed' && (order?.confirmedBy?.toLowerCase() === 'admin' || order?.confirmedBy === null )) ? "Vendita Confermata" :
                    order.status.toLowerCase() === 'refused' ? "Vendita Rifiutata" :
                    order.status.toLowerCase() === 'notaccepted' ? "Non accettato" :
                    order.status.toLowerCase() === 'emailed' ? "Vendita Inviata" : "--"
                  }}
                </ng-template>
            </div>

            <div class="item nowrap">
              
                <span class="data-row-left btn-container">
                    <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); confirmSale(order);" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')) && ((order?.status?.toLowerCase() === 'new') || (order?.status?.toLowerCase() === 'notaccepted') )">CONFERMA</button>
                    <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault();" [routerLink]="['/business/vendita/edit', order.id]" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')) && ((order?.status?.toLowerCase() === 'new') || (order?.status?.toLowerCase() === 'notaccepted') )">MODIFICA</button>
                    <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); refuseSale(order.orderId);" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')) && ((order?.status?.toLowerCase() === 'new') || (order?.status?.toLowerCase() === 'notaccepted') )">RIFIUTA</button>
                    <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); stopSaleAutomation(order);" *ngIf="((groups.includes('admin') || groups.includes('operation')) && (order.status.toLowerCase() === 'emailed') && (order.saleType?.toLowerCase() === 'nonunique'))" [disabled]="btnDisable">INTERROMPI</button>
                </span>
             
            </div>

        </div>
    </div>
</section>
-->